import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import CsvDownloader from "react-csv-downloader";
import ReactPaginate from "react-paginate";
// import toast from "react-hot-toast";
// import appointmentService from '../../../Services/appointmentService'
import authService from "../../Services/authService";
// import ClinicReportService from '../../../Services/clinicReportService'
import utils from "../../Utils";
import constants from "../../Utils/constants";
import strings from "../../Utils/strings";
import TableFilter from "../../Widgets/tableFilter/tableFilter";
import Widgets from "../../Widgets";
import "./clinicReport.css";
import "./clinicTable.css";
import "./report.css";
import { t } from "../../Utils/translate";
import ClinicReportService from "../../Services/clinicReportService";
import clinicService from "../../Services/clinicService";

const ClinicTable = () => {
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(2);
  const [doctorPage, setDoctorPage] = useState(1);
  const [doctorPageCount, setDoctorPageCount] = useState(0);
  const [appointmentTable, setAppointmentTable] = useState(true);
  const [filterContainer, setFilterContainer] = useState(false);
  const [doctorGenderContainer, setDoctorGenderContainer] = useState(false);
  const [doctorFilterContainer, setDoctorFilterContainer] = useState(false);
  const [callTypeContainer, setCallTypeContainer] = useState(false);
  const [appointmentStatusContainer, setAppointmentStatusContainer] = useState(false);
  const [appointmentData, setAppointmentData] = useState([]);
  const [doctorData, setDoctorData] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [checkedDoctorList, setCheckedDoctorList] = useState([]);
  const [openExportPopup, setOpenExportPopup] = useState(false);
  const [openSchedulePopup, setOpenSchedulePopup] = useState(false);
  const [unitFor, setUnitFor] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [currentDate, setCurrentDate] = useState("");
  const [doctorExportData, setDoctorExportData] = useState([]);
  const [appointmentExportData, setAppointmentExportData] = useState([]);
  const [doctorLoginAppointmentExportData, setDoctorLoginAppointmentExportData] = useState([]);
  const [defaultDoctorValue, setDefaultDoctorValue] = useState("");
  const inputFile = useRef(null);
  const [viewFilterList, setViewFilterList] = useState(utils.constants.filter.viewAllFilterList.map((o) => ({ ...o })));
  const [viewDoctorFilterList, setViewDoctorFilterList] = useState(utils.constants.doctorFilter.viewAllDoctorFilterList.map((o) => ({ ...o })));
  const [doctorGenderFilterList, setDoctorGenderFilterList] = useState(utils.constants.doctorGenderFilterList.doctorGenderList.map((o) => ({ ...o })));
  const [callTypeFilterList, setCallTypeFilterList] = useState(utils.constants.filter.callTypeFilterList.map((o) => ({ ...o })));
  const [appointmentStatusFilterList, setAppointmentStatusFilterList] = useState(utils.constants.filter.appointmentStatusFilterList.map((o) => ({ ...o })));
  const [doctorFilterList, setDoctorFilterList] = useState([]);
  const [filterType, setFilteredType] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [appointmentList, setAppointmentList] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [totalAppointments, setTotalAppointments] = useState();
  const [limit, setLimit] = useState();
  const [doctorRevenueData, setDoctorRevenueData] = useState();
  const [isLangEn, setIsLangEn] = useState(true);

  useEffect(() => {
    const language = localStorage.getItem("i18nextLng");
    if (language) {
      let langCode;
      switch (language) {
        case "en-US":
          langCode = "en";
          break;
        case "vietnam":
          langCode = "vietnam";
          break;
        case "en":
          langCode = "en";
          break;
        default:
          langCode = "en";
      }
      if (langCode !== "en") {
        setIsLangEn(false);
      }
    }
  }, []);

  const getAllCompletedAppointments = async () => {
    try {
      const response = await clinicService.getCompletedAppointments(limit, currentPage);
      // let response;
      if (response && response?.status === "success") {
        const data = response?.data;
        console.log("Appointments data:", data);
        setAppointmentList(data);
        setAppointmentData(data);
        setLimit(data.limit);
        setTotalAppointments(data.totalAppointments);
        setTotalPages(data.totalPages);
        // setCurrentPage(data.currentPage)
      } else {
        console.warn("Failed to fetch appointments: ", response?.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error fetching completed appointments:", error);
    }
  };
  const getAllCompletedAppointmentsDoctors = async () => {
    try {
      const response = await clinicService.getDoctorsAppointments(limit, currentPage);
      // let response;
      if (response && response?.status === "success") {
        const data = response?.data;
        console.log("Appointments data:", data);
        setAppointmentList(data);
        setAppointmentData(data);
        setLimit(data.limit);
        setTotalAppointments(data.totalAppointments);
        setTotalPages(data.totalPages);
        // setCurrentPage(data.currentPage)
      } else {
        console.warn("Failed to fetch appointments: ", response?.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error fetching completed appointments:", error);
    }
  };
  const getDoctorRevenue = async () => {
    try {
      // setIsLoading(true);

      const response = await clinicService.getDoctorRevenue();
      if (response && response.status === "success") {
        const Data = response.data?.doctors;
        setDoctorRevenueData(Data);
      } else {
        console.warn("API response was not successful:", response);
      }
    } catch (error) {
      console.error("Error fetching clinic report:", error);
    } finally {
      // setIsLoading(false);
    }
  };
  useEffect(() => {
    if (authService.getIsDoctorLogin() === "false") {
      getDoctorRevenue();
    }
  }, []);
  console.log(doctorRevenueData?.doctors);
  useEffect(() => {
    if (authService.getIsDoctorLogin() === "false") {
      getAllCompletedAppointments();
    } else if (authService.getIsDoctorLogin() === "true") {
      getAllCompletedAppointmentsDoctors();
    }
  }, [currentPage]);

  console.log(appointmentList);
  useEffect(() => {
    if (authService.getIsDoctorLogin() == "true") {
      doctorAppointmentTable();
    } else {
      clinicAppointmentTable();
    }
  }, [page, doctorPage, doctorGenderFilterList, callTypeFilterList, appointmentStatusFilterList, filterType]);

  async function doctorList() {
    try {
      // let response = await appointmentService.getDoctorList(utils.constants.doctorType.slot);
      let response;
      if (response) {
        if (response.status) {
          let data = response.response;
          let arr = [];

          data.map((item) => {
            let obj = {
              status: false,
              allType: false,
              value: item._id,
              label: item.doctorName,
            };
            arr.push(obj);
          });
          setDefaultDoctorValue(arr[0]);
          setDoctorFilterList(arr);
        }
      }
    } catch (error) {
      // toast.dismiss();
      // toast.error(error.message)
    }
  }
  async function clinicAppointmentExport() {
    try {
      let body = {
        doctorId: curateFilterList(doctorFilterList),
        gender: curateFilterList(doctorGenderFilterList),
        callType: curateFilterList(callTypeFilterList),
        status: curateFilterList(appointmentStatusFilterList),
        filterType: filterType ? strings.addDoctor.label_scheduled : false,
        from: startDate,
        to: endDate,
      };
      // let response = await ClinicReportService.clinicAppointmentExport(body)
      let response;
      if (response && response.status) {
        let data = response.response;
        data.map((item, i) => {
          if (checkedList.includes(utils.strings.clinicReport.age)) {
            delete item.patientAge;
          }

          if (checkedList.includes(strings.miscellaneous.symptoms)) {
            delete item.symptoms;
          }

          if (checkedList.includes(strings.welcome.label_doctor)) {
            delete item.doctorName;
          }

          if (checkedList.includes(strings.clinicReport.type)) {
            delete item.isCalenderBasedAppointment;
          }

          if (checkedList.includes(strings.miscellaneous.consultType)) {
            delete item.callType;
          }

          if (checkedList.includes(strings.clinicReport.status)) {
            delete item.appointmentState;
          }

          if (checkedList.includes(strings.clinicReport.consultFee)) {
            delete item.consultFee;
          }

          if (checkedList.includes(strings.addDoctor.label_schedule)) {
            delete item.startTime;
          }

          if (checkedList.includes(strings.clinicReport.phoneNo)) {
            delete item.patientMobileNumber;
          }
        });

        if (unitFor == strings.clinicReport.xls) {
          utils.utilFunctions.exportData(data, "Appointment-Report.xlsx");
        } else {
          setAppointmentExportData(data);
        }
      }
    } catch (error) {
      // toast.dismiss();
      // toast.error(error.message)
    }
  }
  async function clinicDoctorExport() {
    try {
      let obj = {
        from: startDate,
        to: endDate,
      };
      // let response = await ClinicReportService.clinicDoctorExport(obj)
      let response;
      if (response && response.status) {
        let data = response.response;
        data.map((item, i) => {
          if (checkedDoctorList.includes("Specialization")) {
            delete item.patientAge;
          }

          if (checkedDoctorList.includes("Qualification")) {
            delete item.qualification;
          }

          if (checkedDoctorList.includes("Type")) {
            delete item.isCalender;
          }

          if (checkedDoctorList.includes("Experience")) {
            delete item.experience;
          }

          if (checkedDoctorList.includes(strings.appointment.appointments)) {
            delete item.appointmentCount;
          }

          if (checkedDoctorList.includes("Revenue")) {
            delete item.revenue;
          }

          if (checkedDoctorList.includes(strings.clinicReport.phoneNo)) {
            delete item.phoneNumber;
          }
        });
        setDoctorExportData(data);
        if (unitFor == strings.clinicReport.xls) {
          utils.utilFunctions.exportData(data, "Doctor-Report.xlsx");
        }
      }
    } catch (error) {
      // toast.dismiss();
      // toast.error(error.message)
    }
  }
  async function doctorLoginAppointmentExport() {
    try {
      let obj = {
        from: startDate,
        to: endDate,
      };
      // let response = await ClinicReportService.doctorLoginAppointmentExport(obj)
      let response;
      if (response) {
        let data = response.response;
        data.map((item, i) => {
          if (checkedList.includes(utils.strings.clinicReport.age)) {
            delete item.patientAge;
          }

          if (checkedList.includes(strings.miscellaneous.symptoms)) {
            delete item.symptoms;
          }

          if (checkedList.includes(strings.welcome.label_doctor)) {
            delete item.doctorName;
          }

          if (checkedList.includes(strings.clinicReport.type)) {
            delete item.isCalenderBasedAppointment;
          }

          if (checkedList.includes(strings.miscellaneous.consultType)) {
            delete item.callType;
          }

          if (checkedList.includes(strings.clinicReport.status)) {
            delete item.appointmentState;
          }

          if (checkedList.includes(strings.clinicReport.consultFee)) {
            delete item.consultFee;
          }

          if (checkedList.includes(strings.addDoctor.label_schedule)) {
            delete item.startTime;
          }

          if (checkedList.includes(strings.clinicReport.phoneNo)) {
            delete item.patientMobileNumber;
          }
        });

        setDoctorLoginAppointmentExportData(data);
        if (unitFor == strings.clinicReport.xls) {
          utils.utilFunctions.exportData(data, "Doctor-Report.xlsx");
        }
      }
    } catch (error) {
      // toast.dismiss();
      // toast.error(error.message)
    }
  }
  function curateFilterList(list) {
    const arr = [];
    list &&
      list.map((item, i) => {
        if (item.status) {
          arr.push(item.value !== undefined ? item.value : item.label);
        }
      });
    return arr;
  }
  async function clinicAppointmentTable(isScheduled) {
    try {
      let statusArr = curateFilterList(appointmentStatusFilterList);

      const res = statusArr.find((item) => item === utils.constants.appointmentState.cancelled);

      if (res == utils.constants.appointmentState.cancelled) {
        statusArr.push(utils.constants.appointmentState.calendarCancelled);
      }

      let body = {
        doctorId: curateFilterList(doctorFilterList),
        gender: curateFilterList(doctorGenderFilterList),
        callType: curateFilterList(callTypeFilterList),
        status: statusArr,
        filterType: filterType ? strings.addDoctor.label_scheduled : false,
      };
      if (filterType) {
        body["from"] = startDate;
        body["to"] = endDate;
      } else {
        body["from"] = null;
        body["to"] = null;
      }
      const newPage = page ? page : 1;
      // setIsLoading(true)
      // let response = await ClinicReportService.clinicAppointmentTable(body, newPage)
      let response;
      setIsLoading(false);
      if (response) {
        let data = response.response[0].result;
        setAppointmentData(data);
        let pageCount = 0;
        if (response.response[0].totalCount && response.response[0].totalCount.length > 0 && response.response[0].totalCount[0].count) {
          pageCount = Math.round(response.response[0].totalCount[0].count / 10);
        }
        setPageCount(pageCount);
      } else {
      }
    } catch (error) {
      // toast.dismiss();
      // toast.error(error.message)
      setIsLoading(false);
    }
  }
  async function doctorAppointmentTable() {
    try {
      let body = {
        gender: curateFilterList(doctorGenderFilterList),
        callType: curateFilterList(callTypeFilterList),
        status: curateFilterList(appointmentStatusFilterList),
        filterType: filterType ? strings.addDoctor.label_scheduled : false,
      };
      if (filterType) {
        body["from"] = startDate;
        body["to"] = endDate;
      } else {
        body["from"] = null;
        body["to"] = null;
      }
      const newPage = page ? page : 1;
      setIsLoading(true);
      // let response = await ClinicReportService.doctorAppointmentTable(body, newPage)
      let response;
      setIsLoading(false);
      let data = response.response[0].result;
      setAppointmentData(data);
      let pageCount = 0;
      if (response.response[0].totalCount && response.response[0].totalCount.length > 0 && response.response[0].totalCount[0].count) {
        pageCount = Math.round(response.response[0].totalCount[0].count / 10);
      }
      setPageCount(pageCount);
    } catch (error) {
      // toast.dismiss();
      // toast.error(error.message)
      setIsLoading(false);
    }
  }
  async function clinicDoctorTable() {
    try {
      const newDoctorPage = doctorPage ? doctorPage : 1;
      // let response = await ClinicReportService.clinicDoctorTable(newDoctorPage)
      let response;
      let data = response.response[0].result;
      setDoctorData(data);
      let doctorPageCount = Math.round(response.response[0].totalCount[0] && response.response[0].totalCount[0].count / 10);
      setDoctorPageCount(doctorPageCount);
    } catch (error) {
      // toast.dismiss();
      // toast.error(error.message)
    }
  }

  function getAgeFromDateOfBirth(patientAge) {
    const xp = utils.utilFunctions.getAge(patientAge);
    if (xp == utils.strings.miscellaneous.justBorn) {
      return strings.clinicReport.intern;
    } else {
      return xp;
    }
  }

  function appointmentFilterHandler(e) {
    let arr = [];
    e.map((item, i) => {
      if (item.status) {
        arr.push(item.label);
      }
    });
    setCheckedList(arr);
    setFilterContainer(false);
  }

  function doctorFilterHandler(e) {
    let arr = [];
    e.map((item, i) => {
      if (item.status) {
        arr.push(item.label);
      }
    });
    setCheckedDoctorList(arr);
    setFilterContainer(false);
  }

  function renderScheduleView() {
    return (
      <>
        <div className="custom-calendar-input-view">
          <div className="d-flex align-items-center">
            <span className="me-2">{t("labelFrom")}</span>
            <input
              type="date"
              className="form-control generate-text"
              max={endDate}
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
            />
          </div>
          <div className="d-flex align-items-center">
            <span className="mx-3">{t("labelTo")}</span>
            <input
              type="date"
              className="form-control generate-text"
              min={startDate}
              value={endDate}
              max={currentDate}
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
            />
          </div>
        </div>
      </>
    );
  }

  function renderExportView() {
    return (
      <>
        <div>
          <span>{t("duration")}</span>
        </div>
        <div className="mt-2">
          <div className="custom-calendar-input-view">
            <div className="d-flex align-items-center">
              <span className="me-2">{t("labelFrom")}</span>
              <input
                type="date"
                className="form-control generate-text"
                max={endDate}
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              />
            </div>
            <div className="d-flex align-items-center">
              <span className="mx-3">{t("labelTo")}</span>
              <input
                type="date"
                className="form-control generate-text"
                min={startDate}
                value={endDate}
                max={moment().add(30, "days").format(constants.dateFormat.yearMonthDate)}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="mt-3">
            <span>{t("selectFormat")}</span>
            <div
              onClick={(e) => {
                setUnitFor(e.target.value);
                if (e.target.value && authService.getIsDoctorLogin() == "true") {
                  doctorLoginAppointmentExport();
                }
                if (e.target.value == strings.clinicReport.csv && appointmentTable) {
                  clinicAppointmentExport();
                } else if (e.target.value == strings.clinicReport.xls && !appointmentTable) {
                  clinicDoctorExport();
                }
              }}
            >
              <div className="d-flex mt-2">
                <div className="d-flex align-items-center me-4">
                  <input type="radio" value={strings.clinicReport.csv} name="unitFor" className="app-input" checked={unitFor === strings.clinicReport.csv} />
                  <label className="label-texts ms-2">{strings.clinicReport.csv}</label>
                </div>
                <div className="d-flex align-items-center me-4">
                  <input type="radio" value={strings.clinicReport.xls} name="unitFor" className="app-input" checked={unitFor === strings.clinicReport.xls} />
                  <label className="label-texts ms-2">{strings.clinicReport.xls}</label>
                </div>

                <div className="d-none">
                  <CsvDownloader
                    ref={inputFile}
                    filename={appointmentTable ? "Appointment-Report" : "Doctor-Report"}
                    extension=".csv"
                    separator=";"
                    wrapColumnChar="'"
                    datas={authService.getIsDoctorLogin() == "true" ? doctorLoginAppointmentExportData : appointmentTable ? appointmentExportData : doctorExportData}
                    text="DOWNLOAD"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  async function resetAppointmentFilter() {
    setViewFilterList(utils.constants.filter.viewAllFilterList.map((o) => ({ ...o })));
    setDoctorGenderFilterList(utils.constants.doctorGenderFilterList.doctorGenderList.map((o) => ({ ...o })));
    await doctorList();
    setCallTypeFilterList(utils.constants.filter.callTypeFilterList.map((o) => ({ ...o })));
    setAppointmentStatusFilterList(utils.constants.filter.appointmentStatusFilterList.map((o) => ({ ...o })));
  }

  function resetDoctorFilter() {
    setViewDoctorFilterList(utils.constants.doctorFilter.viewAllDoctorFilterList.map((o) => ({ ...o })));
  }

  return (
    <React.Fragment>
      <div className="col-lg-12 pt-2  custom-padding">
        <div className="table-tabs">
          <div className="d-flex">
            <span
              className={appointmentTable ? "active-tabs me-5" : "in-active-tabs me-5"}
              onClick={() => {
                setAppointmentTable(true);
              }}
            >
              {t("appointments")}
            </span>
            {authService.getIsDoctorLogin() == "false" && (
              <span
                className={!appointmentTable ? "active-tabs" : "in-active-tabs"}
                onClick={() => {
                  setAppointmentTable(false);
                }}
              >
                {t("doctor_label")}
              </span>
            )}
          </div>

          {/* <div className='table-tabs-col-2'>
               <div className='me-3'
                   style={{
                       position: "relative",
                   }}
               >
                   <div className='d-flex align-items-center' onClick={() => {
                       setFilterContainer(!filterContainer)
                       setDoctorFilterContainer(false)
                       setCallTypeContainer(false)
                       setDoctorGenderContainer(false)
                       setAppointmentStatusContainer(false)
                   }}>
                       <span className='table-view-btn me-2'>{t('view')}</span>
                       <i className='ri-filter-3-line table-filter-icon'></i>
                   </div>

                   {
                       filterContainer &&
                       <div className='table-view-filter-container'>
                           <TableFilter
                               okClassName="table-filter-btn okay-btn"
                               cancelClassName="table-filter-btn cancel-btn"
                               checkboxClassName="appointment-request-checkbox"
                               list={appointmentTable ? viewFilterList : viewDoctorFilterList}
                               onCancelClick={() => {
                                   setFilterContainer(false)
                               }}
                               onOkClick={(e) => {
                                   appointmentTable ? setViewFilterList(e) : setViewDoctorFilterList(e);
                                   appointmentTable ? appointmentFilterHandler(e) : doctorFilterHandler(e);
                               }}
                           />
                       </div>
                   }
               </div>
               <div className='me-3'>
                   <button className='btn reset-btn' onClick={async () => {
                       if (appointmentTable) {
                           setCheckedList([])
                           await resetAppointmentFilter()
                           setFilteredType(false)
                       } else if (!appointmentTable) {
                           setCheckedDoctorList([])
                           resetDoctorFilter()
                       }
                   }}>{t('resetAll')}</button>
               </div>
               <div>
                   <button className='btn export-btn d-flex align-items-center'
                       onClick={() => {
                           setOpenExportPopup(true)
                           if (authService.getIsDoctorLogin() == 'true') {
                               doctorLoginAppointmentExport()
                           } else if (appointmentTable) {
                               clinicAppointmentExport()
                           } else if (!appointmentTable) {
                               clinicDoctorExport()
                           }
                       }}><i className='ri-share-forward-box-fill me-2'></i>{t('export')}
                   </button>
               </div>
           </div> */}
        </div>
      </div>

      {appointmentTable && (
        <div>
          <div
            style={{
              overflow: "auto",
              minHeight: "300px",
              width: "100%",
            }}
          >
            <table className="table clinic-appointment-table">
              <thead>
                <tr className="custom-border-bottom">
                  <th scope="col" className="first custom-border" style={{ border: "none" }}></th>
                  <th scope="col" className="custom-border">
                    {t("patient")}
                  </th>
                  {checkedList.includes(strings.clinicReport.phoneNo) ? null : (
                    <th scope="col" className=" custom-border">
                      {t("phoneNo")}
                    </th>
                  )}
                  {checkedList.includes(strings.clinicReport.age) ? null : (
                    <th scope="col" className=" custom-border">
                      {t("labelDOB")}
                    </th>
                  )}
                  <th scope="col" className="position-relative  custom-border">
                    {t("labelGender")}
                    {/* <i
                           className='ri-filter-3-line table-filter-icon' onClick={() => {
                               setDoctorGenderContainer(!doctorGenderContainer)
                               setFilterContainer(false)
                               setCallTypeContainer(false)
                               setDoctorFilterContainer(false)
                               setAppointmentStatusContainer(false)
                           }}></i> */}
                    {/* {doctorGenderContainer &&
                               <div className='table-view-filter-container'>
                                   <TableFilter
                                       okClassName="table-filter-btn okay-btn"
                                       cancelClassName="table-filter-btn cancel-btn"
                                       checkboxClassName="appointment-request-checkbox"
                                       list={doctorGenderFilterList}
                                       onCancelClick={() => {
                                           setDoctorGenderContainer(false)
                                       }}
                                       onOkClick={(e) => {
                                        console.log(e)
                                           setDoctorGenderFilterList(e)
                                           clinicAppointmentTable(true)
                                           setDoctorGenderContainer(false)
                                       }}
                                   />
                               </div>} */}
                  </th>

                  {checkedList.includes(strings.miscellaneous.symptoms) ? null : (
                    <th scope="col" className=" custom-border">
                      {t("symptoms")}
                    </th>
                  )}
                  {checkedList.includes(strings.welcome.label_doctor) || authService.getIsDoctorLogin() == "true" ? null : (
                    <th scope="col" className="position-relative  custom-border">
                      {t("label_doctor")}
                      {/* <i
                               className='ri-filter-3-line table-filter-icon' onClick={() => {
                                   setDoctorFilterContainer(!doctorFilterContainer)
                                   setDoctorGenderContainer(false)
                                   setFilterContainer(false)
                                   setCallTypeContainer(false)
                                   setAppointmentStatusContainer(false)
                               }}></i> */}
                      {doctorFilterContainer && (
                        <div className="table-view-filter-container">
                          <TableFilter
                            okClassName="table-filter-btn okay-btn"
                            cancelClassName="table-filter-btn cancel-btn"
                            checkboxClassName="appointment-request-checkbox"
                            list={doctorFilterList}
                            onCancelClick={() => {
                              setDoctorFilterContainer(false);
                            }}
                            onOkClick={(e) => {
                              setDoctorFilterList(e);
                              clinicAppointmentTable();
                              setDoctorFilterContainer(false);
                            }}
                          />
                        </div>
                      )}
                    </th>
                  )}
                  {/* {checkedList.includes(strings.miscellaneous.consultType) ? null :
                           <th scope="col" className='position-relative  custom-border'>{t('consultType')} <i
                               className='ri-filter-3-line table-filter-icon' onClick={() => {
                                   setCallTypeContainer(!callTypeContainer)
                                   setFilterContainer(false)
                                   setDoctorGenderContainer(false)
                                   setDoctorFilterContainer(false)
                                   setAppointmentStatusContainer(false)
                               }}></i>
                               {
                                   callTypeContainer &&
                                   <div className='table-view-filter-container'>
                                       <TableFilter
                                           tableBodyClassName="table-filter-report"
                                           okClassName="table-filter-btn okay-btn"
                                           cancelClassName="table-filter-btn cancel-btn"
                                           checkboxClassName="appointment-request-checkbox"
                                           list={callTypeFilterList}
                                           onCancelClick={() => {
                                               setCallTypeContainer(false)
                                           }}
                                           onOkClick={(e) => {
                                               setCallTypeFilterList(e)
                                               clinicAppointmentTable()
                                               setCallTypeContainer(false)
                                           }}
                                       />
                                   </div>
                               }
                           </th>} */}
                  {checkedList.includes(strings.clinicReport.status) ? null : (
                    <th scope="col" className="position-relative  custom-border">
                      {t("status")}
                      {/* <i
                               className='ri-filter-3-line table-filter-icon' onClick={() => {
                                   setAppointmentStatusContainer(!appointmentStatusContainer)
                                   setFilterContainer(false)
                                   setCallTypeContainer(false)
                                   setDoctorFilterContainer(false)
                               }}></i> */}
                      {appointmentStatusContainer && (
                        <div className="table-view-filter-container">
                          <TableFilter
                            tableBodyClassName="table-filter-report"
                            okClassName="table-filter-btn okay-btn"
                            cancelClassName="table-filter-btn cancel-btn"
                            checkboxClassName="appointment-request-checkbox"
                            list={appointmentStatusFilterList}
                            onCancelClick={() => {
                              setAppointmentStatusContainer(false);
                            }}
                            onOkClick={(e) => {
                              setAppointmentStatusFilterList(e);
                              clinicAppointmentTable();
                              setAppointmentStatusContainer(false);
                            }}
                          />
                        </div>
                      )}
                    </th>
                  )}
                  {checkedList.includes(strings.clinicReport.consultFee) ? null : (
                    <th scope="col" className=" custom-border">
                      {t("consultFee")}
                    </th>
                  )}
                  {/* {checkedList.includes(strings.addDoctor.label_schedule) ? null :
                           <th scope="col" className=' custom-border'>{t('labelSchedule')} <i
                               className='ri-filter-3-line table-filter-icon' onClick={() => {
                                   setOpenSchedulePopup(true)
                               }}></i></th>} */}
                </tr>
              </thead>
              {isLoading ? (
                <Widgets.CircularLoader />
              ) : (
                <tbody>
                  {appointmentData?.appointments ? (
                    <>
                      {appointmentData?.appointments.map((item, index) => {
                        // Determine the appointment state
                        let appointmentState;
                        switch (item.status) {
                          case "COMPLETED":
                            appointmentState = strings.clinicReport.capitalizeCompleted;
                            break;
                          case "CONFIRMED":
                            appointmentState = strings.clinicReport.confirmed;
                            break;
                          case "REJECTED":
                            appointmentState = strings.clinicReport.rejected;
                            break;
                          case "WAITING_FOR_CLINIC_CONFIRMATION":
                            appointmentState = strings.miscellaneous.doctor_pending;
                            break;
                          case "WAITING_FOR_PATIENT_CONFIRMATION":
                            appointmentState = strings.miscellaneous.patient_pending;
                            break;
                          case "CANCELLED":
                            appointmentState = strings.miscellaneous.cancelled;
                            break;
                          case "EXPIRED":
                            appointmentState = strings.clinicReport.expired;
                            break;
                          case "CALENDAR_CANCELLED":
                            appointmentState = strings.miscellaneous.cancelled;
                            break;
                          default:
                            appointmentState = item.status;
                        }

                        // Determine the call type
                        let callType;
                        switch (item.callType) {
                          case "IN_HOUSE_CALL":
                            callType = strings.clinicDashboard.houseCall;
                            break;
                          case "AUDIO":
                            callType = strings.clinicReport.audio;
                            break;
                          case "VIDEO":
                            callType = strings.clinicReport.video;
                            break;
                          default:
                            callType = strings.clinicReport.normal;
                        }

                        // Format the date of birth
                        const date = new Date(item.patient.dateOfBirth);
                        const dob = `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;

                        return (
                          <tr key={item._id}>
                            <td>{index + 1}.</td>
                            <td>{item.patient.fullName}</td>
                            {!checkedList.includes(strings.clinicReport.phoneNo) && (
                              <td>{item.patient.phoneNumber ? `${strings.clinicReport.plus}${item.patient.phoneNumber}` : strings.clinicReport.patientMobileNumberNA}</td>
                            )}
                            <td>{dob}</td>
                            <td>{t(item.patient.gender)}</td>
                            {!checkedList.includes(strings.miscellaneous.symptoms) && <td>{item.symptoms.join(", ")}</td>}
                            {!checkedList.includes(strings.welcome.label_doctor) && authService.getIsDoctorLogin() !== "true" && <td>{isLangEn ? item.doctor.name.en : item.doctor.name.vi}</td>}
                            {/* {!checkedList.includes(strings.miscellaneous.consultType) && (
                <td className="callType">{item.isInstantVideo ? t('Instant Video') : t(callType)}</td>
              )} */}
                            {!checkedList.includes(strings.clinicReport.status) && <td>{t(appointmentState)}</td>}
                            {!checkedList.includes(strings.clinicReport.consultFee) && <td>{item.paymentInfo.paid > 0 ? `${item.paymentInfo.currencySymbol}${item.paymentInfo.paid}` : 0}</td>}
                            {/* {!checkedList.includes(strings.addDoctor.label_schedule) && (
                <td>{`${item.appointmentDate} | ${moment(item.startTime).format('LT')}`}</td>
              )} */}
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <span className="appointment-unavailable">{t("noAppointment")}</span>
                  )}
                </tbody>
              )}
            </table>
          </div>

          {totalPages > 0 && (
            <div className="clinic-pagination mt-5">
              <ReactPaginate
                breakLabel="..."
                nextLabel={currentPage < totalPages ? <i className="ri-arrow-right-circle-line"></i> : null}
                previousLabel={currentPage > 1 ? <i className="ri-arrow-left-circle-line" /> : null}
                onPageChange={(e) => {
                  const selectedPage = e.selected + 1;
                  setCurrentPage(selectedPage);
                }}
                activeClassName={"active-page"}
                pageRangeDisplayed={1}
                pageCount={totalPages}
                forcePage={currentPage - 1} // to sync with the current page state
              />
            </div>
          )}
        </div>
      )}
      {!appointmentTable && authService.getIsDoctorLogin() == "false" && (
        <div>
          <div style={{ overflow: "auto", width: "100%" }}>
            <table className="table clinic-doctor-table">
              <thead>
                <tr className="custom-border-bottom">
                  <th scope="col" className="custom-border"></th>
                  <th scope="col" className="custom-border">
                    {t("label_doctor")}
                  </th>
                  {checkedDoctorList.includes(strings.clinicReport.specialization) ? null : (
                    <th scope="col" className="custom-border">
                      {t("specialization")}
                    </th>
                  )}
                  {checkedDoctorList.includes(strings.clinicProfile.label_qualification) ? null : (
                    <th scope="col" className="custom-border">
                      {t("labelQualification")}
                    </th>
                  )}
                  {/* {checkedDoctorList.includes(strings.clinicReport.type) ? null :
                           <th scope="col"  className='custom-border'>{t('type')}</th>} */}
                  {checkedDoctorList.includes(strings.doctorProfile.label_experience) ? null : (
                    <th scope="col" className="custom-border">
                      {t("label_experience")}
                    </th>
                  )}
                  {checkedDoctorList.includes(strings.appointment.appointments) ? null : (
                    <th scope="col" className="custom-border">
                      {t("appointments")}
                    </th>
                  )}
                  {checkedDoctorList.includes(strings.clinicReport.revenue) ? null : (
                    <th scope="col" className="custom-border">
                      {t("revenue")}
                    </th>
                  )}
                  {checkedDoctorList.includes(strings.clinicReport.phoneNo) ? null : (
                    <th scope="col" className="custom-border">
                      {t("phoneNo")}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {doctorRevenueData.map((item, index) => {
                  return (
                    <tr key={item._id}>
                      {console.log(item)}
                      <td>{index + 1}.</td>
                      <td>{isLangEn ? item.name.en : item.name.vi}</td>

                      {checkedDoctorList.includes(strings.clinicReport.specialization) ? null : <td>{isLangEn ? item.department?.en : item.department?.vi}</td>}

                      {checkedDoctorList.includes(strings.clinicProfile.label_qualification) ? null : <td>{isLangEn ? item.qualification?.en : item.qualification?.vi}</td>}

                      {/* {checkedDoctorList.includes(strings.clinicReport.type) ? null : (
          <td>{item.isCalender ? strings.clinicReport.calendarBased : strings.clinicReport.slotBased}</td>
        )} */}

                      {checkedDoctorList.includes(strings.doctorProfile.label_experience) ? null : <td>{item.workExperience !== null ? item.workExperience : ""}</td>}

                      {checkedDoctorList.includes(strings.appointment.appointments) ? null : <td>{item.totalAppointments}</td>}

                      {checkedDoctorList.includes(strings.clinicReport.revenue) ? null : (
                        <td>
                          <div className="revenue-cell">{item.currencySymbol && item.totalRevenue ? `${item.currencySymbol} ${item.totalRevenue}` : "0"}</div>
                        </td>
                      )}

                      {checkedDoctorList.includes(strings.clinicReport.phoneNo) ? null : (
                        <td>
                          <div className="phone-cell">{item.phoneNumber ? `${strings.clinicReport.plus}${item.countryCode}${item.phoneNumber}` : strings.clinicReport.patientMobileNumberNA}</div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {doctorPageCount > 1 ? (
            <div className="clinic-pagination mt-5">
              {totalPages > 0 && (
                <div className="clinic-pagination mt-5">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={currentPage < totalPages ? <i className="ri-arrow-right-circle-line"></i> : null}
                    previousLabel={currentPage > 1 ? <i className="ri-arrow-left-circle-line" /> : null}
                    onPageChange={(e) => {
                      const selectedPage = e.selected + 1;

                      setCurrentPage(selectedPage);
                    }}
                    activeClassName={"active-page"}
                    pageRangeDisplayed={1}
                    pageCount={totalPages}
                    forcePage={currentPage - 1} // to sync with the current page state
                  />
                </div>
              )}
            </div>
          ) : null}
        </div>
      )}

      {openSchedulePopup ? (
        <Widgets.AppDialog
          widthType={utils.constants.dialogWidthType.regular}
          setVisibility={(e) => {
            setOpenSchedulePopup(e);
          }}
          dialogTitle={t("labelSchedule")}
          view={renderScheduleView()}
          dialogPositiveBtnText={t("confirm")}
          dialogPositiveBtnCall={() => {
            setFilteredType(true);
            setOpenSchedulePopup(false);
            if (authService.getIsDoctorLogin() == "true") {
              doctorAppointmentTable();
            }
          }}
        />
      ) : null}

      {openExportPopup ? (
        <Widgets.AppDialog
          widthType={utils.constants.dialogWidthType.regular}
          setVisibility={(e) => {
            setOpenExportPopup(e);
          }}
          dialogTitle={t("Export")}
          view={renderExportView()}
          dialogPositiveBtnText={strings.clinicReport.export}
          dialogPositiveBtnCall={() => {
            if (unitFor == strings.clinicReport.csv) {
              inputFile.current.handleClick();
            } else if (unitFor == strings.clinicReport.xls && authService.getIsDoctorLogin() == "true") {
              doctorLoginAppointmentExport();
              setOpenExportPopup(false);
              setUnitFor(null);
            } else if (unitFor == strings.clinicReport.xls && appointmentTable) {
              clinicAppointmentExport();
              setOpenExportPopup(false);
              setUnitFor(null);
            } else {
              clinicDoctorExport();
              setOpenExportPopup(false);
              setUnitFor(null);
            }
          }}
          disablePositiveBtn={!unitFor}
        />
      ) : null}
    </React.Fragment>
  );
};

export default ClinicTable;
